import { render, staticRenderFns } from "./DetailVisit.vue?vue&type=template&id=3a5fa9fa&scoped=true&"
import script from "./DetailVisit.vue?vue&type=script&lang=js&"
export * from "./DetailVisit.vue?vue&type=script&lang=js&"
import style0 from "./DetailVisit.vue?vue&type=style&index=0&id=3a5fa9fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5fa9fa",
  null
  
)

export default component.exports